import Rx from "rxjs";

const api = {
  host: process.env.REACT_APP_API_URL,

  searchOrgel: searchTerm => {
    const request = fetch(
      `${api.host}/v3/search-unified-orgel.php?searchterm=${searchTerm}`
    ).then(response => response.json());
    return Rx.Observable.fromPromise(request);
  },
  searchOrgelbauer: searchTerm => {
    const request = fetch(
      `${api.host}/v3/search-unified-orgelbauer.php?searchterm=${searchTerm}`
    ).then(response => response.json());
    return Rx.Observable.fromPromise(request);
  },

  fetchAllDispositionen: id => {
    const request = fetch(
      `${api.host}/v3/details_dispositionen.php?id=${id}`
    ).then(response => response.json());
    return Rx.Observable.fromPromise(request);
  },
  fetchDetails: id => {
    const request = fetch(`${api.host}/v3/details.php?id=${id}`).then(
      response => response.json()
    );
    return Rx.Observable.fromPromise(request);
  },
  fetchBibliographie: id => {
    const request = fetch(
      `${api.host}/v3/details_bibliographie.php?id=${id}`
    ).then(response => response.json());
    return Rx.Observable.fromPromise(request);
  },
  fetchOrgelgeschichte: id => {
    const request = fetch(
      `${api.host}/v3/details_orgelgeschichte.php?id=${id}`
    ).then(response => response.json());
    return Rx.Observable.fromPromise(request);
  },
  fetchMedien: id => {
    const request = fetch(`${api.host}/v3/details_medien.php?id=${id}`).then(
      response => response.json()
    );
    return Rx.Observable.fromPromise(request);
  },
  geoLocations: () => {
    const request = fetch(`${api.host}/v3/geo_locations.php`).then(response =>
      response.json()
    );
    return Rx.Observable.fromPromise(request);
  },
  fetchRecherche: (
    yearFrom,
    yearTo,
    kantone,
    ort,
    orgelbauer,
    massnahmenIncluded,
    massnahmenExcluded
  ) => {
    const request = fetch(
      `${
        api.host
      }/v3/recherche.php?yearFrom=${yearFrom}&yearTo=${yearTo}&kantone=${kantone}&ort=${ort}&orgelbauer=${orgelbauer}&&massnahmenIncluded=${massnahmenIncluded}&massnahmenExcluded=${massnahmenExcluded}`
    ).then(response => response.json());
    return Rx.Observable.fromPromise(request);
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js